import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloConfigBase  {   
}

export const getDefaultAloConfigBase = ():AloConfigBase => {
    return {  
        
    }
}

export const cleanAloConfigBase = (config:AloConfigBase) => {    
    if(!config) return        
}